import { CoffeeIcon } from "../../../loading/components/CoffeeIcon"
import { PrimaryFeatureFrame } from "../PrimaryFeatureFrame"

export function Analyse() {
    return (
        <PrimaryFeatureFrame>
            <div className="flex h-full flex-col justify-center">
                <div className="mx-auto">
                    <CoffeeIcon className="mx-auto size-36" color="#00adb5" />
                    <div className="text-center">
                        <h1 className="mb-8 text-center text-sm font-bold text-gray-700">Analysing</h1>
                        <p className="text-xs text-gray-500">
                            This will take two to five minutes
                            <br />
                        </p>
                        <p className="text-xs text-gray-500">Grab a coffee and come back soon</p>
                    </div>
                </div>
            </div>
        </PrimaryFeatureFrame>
    )
}
